import React from 'react';
import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import Section from '@hero/ui-kit/layout/Section';
import P from '@hero/ui-kit/typography/P';

import * as Style from '../style.module.scss';
import { CareMonthOverview } from '../types';

const FILTER_LABELS: Record<string, string> = {
    'On hold': 'Blocked',
    'Awaiting evidence': 'Not calculated',
    'No longer eligible': 'Removed from billing'
};

type Props = {
    counts?: CareMonthOverview['current_status_counts'];
    filter: string | null;
    onFilter: (value: string | null) => void;
    filters: React.ReactNode;
    controls: React.ReactNode;
};

const StatusSummary: React.FC<Props> = ({ counts, filter, onFilter, filters, controls }) => {
    const cards = [
        {
            status: null,
            label: 'All codes',
            count: counts ? counts.candidate_rows + counts.no_longer_eligible_rows : null
        },
        ...Object.entries(counts?.by_status ?? {}).map(([status, count]) => ({
            status,
            label: FILTER_LABELS[status] ?? status,
            count
        })),
        {
            status: 'No longer eligible',
            label: FILTER_LABELS['No longer eligible'],
            count: counts?.no_longer_eligible_rows ?? null
        }
    ];
    return (
        <Section noDefaultPadding className={Style.outcomes}>
            <div className={Style.outcomesHeader}>
                <div className={Style.outcomeFilters}>{filters}</div>
                <div className={Style.outcomeControls}>{controls}</div>
            </div>
            <div className={Style.outcomeCards} aria-label="Filter billing code rows">
                {cards.map(({ status, label, count }) => (
                    <ClickableOpacity
                        key={status ?? 'all'}
                        alt={`Show ${label}`}
                        aria-pressed={filter === status}
                        disabled={!counts}
                        className={`${Style.outcomeCard} ${filter === status ? Style.outcomeCardSelected : ''}`}
                        onClick={() => onFilter(filter === status ? null : status)}
                    >
                        <P size="small" noDefaultMargin>
                            {label}
                        </P>
                        <P size="small" strong noDefaultMargin>
                            {count ?? '—'}
                        </P>
                    </ClickableOpacity>
                ))}
            </div>
            <P size="small" noDefaultMargin>
                {counts?.explanation ?? 'Loading current outcomes…'}
            </P>
        </Section>
    );
};

export default StatusSummary;
